import { useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, ArrowLeft, Filter, Sparkles, Star, ChevronRight } from "lucide-react";

// All cake images from Utsav Bakery
const allCakes = {
  signature: [
    { name: "Paan Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/k5wg48j5_CamScanner%2001-03-2026%2001.20%281%29_10.jpg", tag: "UTSAV EXCLUSIVE", desc: "Unique paan flavored cake - our signature!" },
    { name: "Rasmalai Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/2da47pba_CamScanner%2001-03-2026%2001.00%281%29_1.jpg", tag: "UTSAV EXCLUSIVE", desc: "Indian fusion with saffron & mango" },
    { name: "Rose Pistachio Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/21djo6m9_CamScanner%2001-03-2026%2001.20%281%29_8.jpg", tag: "NEW MENU", desc: "Delicate rose & pistachio flavors" },
    { name: "Gulab Jamun Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/q0g0l9ke_CamScanner%2001-03-2026%2001.20%281%29_16.jpg", tag: "INDIAN FUSION", desc: "Traditional Indian sweet cake" },
    { name: "Motichoor Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/r8ik6i7b_CamScanner%2001-03-2026%2001.20%281%29_15.jpg", tag: "INDIAN FUSION", desc: "Sweet ladoo flavored delight" },
  ],
  cakes: [
    { name: "Chocolate Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/iwtjddqu_CamScanner%2001-03-2026%2001.20%281%29_7.jpg", desc: "Rich chocolate with gold decor" },
    { name: "Red Velvet Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/gz3tgb0c_CamScanner%2001-03-2026%2001.00%281%29_9.jpg", desc: "Classic red velvet with cream cheese" },
    { name: "Black Forest Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/n4wmx05v_CamScanner%2001-03-2026%2001.00%281%29_8.jpg", desc: "Chocolate with cherries" },
    { name: "Vanilla Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/hx2ad1re_CamScanner%2001-03-2026%2001.20%281%29_1.jpg", desc: "Classic vanilla with roses & Ferrero" },
    { name: "Coffee Walnut Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/cz46pclu_CamScanner%2001-03-2026%2001.20%281%29_3.jpg", desc: "Coffee flavored with walnuts" },
    { name: "Ferrero Rocher Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/094ein23_CamScanner%2001-03-2026%2001.20%281%29_4.jpg", desc: "Hazelnut chocolate indulgence" },
    { name: "Blueberry Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/1pm4u6lr_CamScanner%2001-03-2026%2001.20%281%29_6.jpg", desc: "Fresh blueberry with gold leaf" },
    { name: "Marble Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/m3q4hw0m_CamScanner%2001-03-2026%2001.20%281%29_14.jpg", desc: "Chocolate vanilla swirl with ganache" },
    { name: "DryFruit Tea Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/od6kvmn5_CamScanner%2001-03-2026%2001.20%281%29_13.jpg", desc: "Loaf with almonds & nuts" },
    { name: "Silver Glitter Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/9mqm6ijf_CamScanner%2001-03-2026%2001.00%281%29_2.jpg", desc: "White rosettes with black ribbons" },
    { name: "Chocolate Rosette Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/lyo9frne_CamScanner%2001-03-2026%2001.20%281%29_17.jpg", desc: "Chocolate swirls with ganache drip" },
    { name: "Chocolate Twin Cakes", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/n20mb7w2_CamScanner%2001-03-2026%2001.20%281%29_12.jpg", desc: "Maltesers & rosettes" },
  ],
  themeCakes: [
    { name: "Unicorn Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/0qynoyac_CamScanner%2001-03-2026%2001.00%281%29_3.jpg", desc: "Magical purple with gold horn" },
    { name: "Butterfly Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/yqir1r3h_CamScanner%2001-03-2026%2001.00%281%29_14.jpg", desc: "Pink ombre with gold butterflies" },
    { name: "Mermaid Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/qfykylz7_CamScanner%2001-03-2026%2001.00%281%29_15.jpg", desc: "Ocean theme with seashells" },
    { name: "Spiderman Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/5m4u56x7_CamScanner%2001-03-2026%2001.00%281%29_20.jpg", desc: "Superhero theme for kids" },
    { name: "Disco Ball Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/5rlmsydy_CamScanner%2001-03-2026%2001.00%281%29_11.jpg", desc: "Pink swirl with mirror balls" },
    { name: "Baby Shower Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/sbpzo3y6_CamScanner%2001-03-2026%2001.00%281%29_25.jpg", desc: "Teddy bear with Baby blocks" },
    { name: "Twin Birthday Cakes", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/919pvpro_CamScanner%2001-03-2026%2001.00%281%29_27.jpg", desc: "Teddy + Rainbow for twins" },
    { name: "Graduation Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/n0unylt1_CamScanner%2001-03-2026%2001.00%281%29_24.jpg", desc: "Cap & scroll for graduates" },
    { name: "Chapter Birthday Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/ycy7r1yx_CamScanner%2001-03-2026%2001.00%281%29_4.jpg", desc: "White with blue flowers" },
    { name: "Funny 30th Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/o4jvmvse_CamScanner%2001-03-2026%2001.00%281%29_17.jpg", desc: "You Still Look 30's - Humor cake" },
    { name: "Turning 30 Meme Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/w03o0add_CamScanner%2001-03-2026%2001.00%281%29_19.jpg", desc: "WHY GOD WHY?! - Funny cake" },
    { name: "Sweet 16 Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/dmrxyy6z_CamScanner%2001-03-2026%2001.00%281%29_21.jpg", desc: "Chocolate celebration cake" },
    { name: "Rose Floral Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/qeox2cyj_CamScanner%2001-03-2026%2001.00%281%29_16.jpg", desc: "Pink with baby's breath flowers" },
    { name: "Pastel Pink & Mint Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/zphm0k9n_CamScanner%2001-03-2026%2001.00%281%29_6.jpg", desc: "Gender reveal / baby shower style" },
    { name: "Blue Gold Leaf Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/58d4t1pc_CamScanner%2001-03-2026%2001.00%281%29_5.jpg", desc: "Modern with golden fan topper" },
  ],
  weddingCakes: [
    { name: "Two-Tier Wedding Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/dv48a7ez_CamScanner%2001-03-2026%2001.00%281%29_12.jpg", desc: "Elegant white roses & silver leaf" },
    { name: "Three-Tier Grey Marble", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/v47oyqps_CamScanner%2001-03-2026%2001.00%281%29_7.jpg", desc: "Grey with black roses & gold balls" },
    { name: "Two-Tier Ferrero Rocher", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/yqir1r3h_CamScanner%2001-03-2026%2001.00%281%29_14.jpg", desc: "Chocolate with gold decor" },
    { name: "Anniversary Cake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/8e0lk4zr_CamScanner%2001-03-2026%2001.20%281%29_11.jpg", desc: "Rose Pistachio with gold pearls" },
  ],
  cupcakes: [
    { name: "Chocolate Cupcake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/ayrll52d_CamScanner%2001-03-2026%2001.20%281%29_20.jpg", desc: "Rich chocolate rosette" },
    { name: "Ferrero Rocher Cupcakes", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/0o1ncoq5_CamScanner%2001-03-2026%2001.20%281%29_21.jpg", desc: "Hazelnut chocolate cupcakes" },
    { name: "Raffaello Cupcakes", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/ejy4q4tx_CamScanner%2001-03-2026%2001.20%281%29_22.jpg", tag: "NEW", desc: "Coconut cream cupcakes" },
    { name: "Red Velvet Cupcake", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/0dzgk1m3_CamScanner%2001-03-2026%2001.20%281%29_19.jpg", desc: "Mini red velvet delight" },
    { name: "Mermaid Theme Cupcakes", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/bxsdecmy_CamScanner%2001-03-2026%2001.20%281%29_23.jpg", desc: "Ocean theme party cupcakes" },
    { name: "Jungle Theme Cupcakes", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/yj8vk90e_CamScanner%2001-03-2026%2001.20%281%29_24.jpg", desc: "Animal toppers for kids" },
  ],
  mousse: [
    { name: "Paan Cake Mousse", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/lmpkayp6_CamScanner%2001-03-2026%2001.00%281%29_13.jpg", tag: "EXCLUSIVE", desc: "Green & white layered cups" },
    { name: "Gulab Jamun Mousse", image: "https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/bj9lrr28_CamScanner%2001-03-2026%2001.00%281%29_10.jpg", desc: "Traditional Indian sweet mousse" },
  ],
};

const categories = [
  { id: "all", name: "All", icon: "🎂" },
  { id: "signature", name: "Signature", icon: "⭐" },
  { id: "cakes", name: "Cakes", icon: "🍰" },
  { id: "themeCakes", name: "Theme Cakes", icon: "🎨" },
  { id: "weddingCakes", name: "Wedding & Tiered", icon: "💒" },
  { id: "cupcakes", name: "Cupcakes", icon: "🧁" },
  { id: "mousse", name: "Mousse", icon: "🥄" },
];

const MenuPage = () => {
  const [activeCategory, setActiveCategory] = useState("all");
  const [selectedCake, setSelectedCake] = useState(null);

  const getFilteredCakes = () => {
    if (activeCategory === "all") {
      return Object.entries(allCakes || {}).flatMap(([category, cakes]) => 
        (cakes || []).map(cake => ({ ...cake, category }))
      );
    }
    return (allCakes[activeCategory] || []).map(cake => ({ ...cake, category: activeCategory }));
  };

  const filteredCakes = getFilteredCakes();

  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="menu-page">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity" data-testid="back-home">
            <ArrowLeft size={20} className="text-[#FF9933]" />
            <img 
              src="https://customer-assets.emergentagent.com/job_0414f390-949e-455d-be81-ddfd0c694b7a/artifacts/qfscq7gd_utsav_an_indian_bakery-20260301-0001.jpg" 
              alt="Utsav Logo" 
              className="w-10 h-10 rounded-full object-cover border-2 border-[#FF9933]/30"
            />
            <span className="font-accent text-2xl text-[#FF9933]">Utsav</span>
          </Link>
          <a
            href="https://wa.me/31685177049?text=Hi! I would like to order a cake from your menu."
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#25D366] text-white px-4 py-2 rounded-full font-semibold flex items-center gap-2 hover:bg-[#128C7E] transition-colors"
            data-testid="header-whatsapp"
          >
            <MessageCircle size={18} />
            <span className="hidden sm:inline">Order Now</span>
          </a>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#FF9933]/10 to-[#B76E79]/10 py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-[#2D2D2D] mb-4" data-testid="menu-title">
            Our Delicious Menu
          </h1>
          <p className="font-body text-lg text-[#555555] max-w-2xl mx-auto mb-6">
            Browse our collection of handcrafted, 100% eggless cakes. Each cake is made fresh to order with love by Chef Jayshree.
          </p>
          <div className="flex items-center justify-center gap-2 text-[#FF9933]">
            <Star size={20} fill="#FFD700" className="text-yellow-400" />
            <span className="font-semibold">5.0 Rating</span>
            <span className="text-[#555555]">• 160+ Happy Customers</span>
          </div>
        </div>
      </section>

      {/* Custom Cake CTA Banner */}
      <section className="bg-gradient-to-r from-[#FF9933] to-[#B76E79] py-8" data-testid="custom-cake-banner">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left text-white">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-2">
                <Sparkles size={24} />
                <span className="font-semibold text-lg">CUSTOM CAKES AVAILABLE!</span>
              </div>
              <p className="text-white/90">
                These are just examples! Tell us your design, theme, or flavor - we'll create it for you! 🎨
              </p>
              <p className="text-white/80 text-sm mt-1">
                For theme cakes, please order 7-10 days in advance
              </p>
            </div>
            <a
              href="https://wa.me/31685177049?text=Hi! I want to order a CUSTOM cake. My requirements are:"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-[#FF9933] px-8 py-3 rounded-full font-bold flex items-center gap-2 hover:bg-gray-100 transition-colors shadow-lg whitespace-nowrap"
              data-testid="custom-cake-btn"
            >
              <MessageCircle size={20} />
              Order Custom Cake
              <ChevronRight size={18} />
            </a>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-6 bg-white border-b sticky top-[72px] z-40">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex items-center gap-2 mb-4">
            <Filter size={18} className="text-[#555555]" />
            <span className="font-semibold text-[#2D2D2D]">Filter by Category:</span>
          </div>
          <div className="flex flex-wrap gap-2" data-testid="category-filters">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`px-4 py-2 rounded-full font-medium transition-all duration-300 flex items-center gap-2 ${
                  activeCategory === cat.id
                    ? "bg-[#FF9933] text-white shadow-lg scale-105"
                    : "bg-gray-100 text-[#555555] hover:bg-gray-200"
                }`}
                data-testid={`filter-${cat.id}`}
              >
                <span>{cat.icon}</span>
                <span>{cat.name}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Cakes Grid */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex items-center justify-between mb-8">
            <p className="text-[#555555]">
              Showing <span className="font-semibold text-[#2D2D2D]">{filteredCakes.length}</span> items
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-testid="cakes-grid">
            {filteredCakes.map((cake, index) => (
              <div
                key={`${cake.name}-${index}`}
                className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer group"
                onClick={() => setSelectedCake(cake)}
                data-testid={`cake-card-${index}`}
              >
                <div className="relative overflow-hidden aspect-square">
                  {cake.tag && (
                    <div className={`absolute top-3 left-3 z-10 px-3 py-1 rounded-full text-xs font-bold text-white ${
                      cake.tag === "UTSAV EXCLUSIVE" ? "bg-gradient-to-r from-[#FF9933] to-[#B76E79]" :
                      cake.tag === "NEW MENU" || cake.tag === "NEW" ? "bg-[#93C572]" :
                      "bg-[#B76E79]"
                    }`}>
                      {cake.tag}
                    </div>
                  )}
                  <img
                    src={cake.image}
                    alt={cake.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                    <span className="text-white font-semibold">Click to view</span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-lg font-semibold text-[#2D2D2D] mb-1 line-clamp-1">
                    {cake.name}
                  </h3>
                  <p className="text-sm text-[#555555] line-clamp-2">{cake.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-12 bg-[#2D2D2D]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h2 className="font-heading text-3xl font-bold text-white mb-4">
            Ready to Order?
          </h2>
          <p className="text-gray-400 mb-6 max-w-xl mx-auto">
            Message us on WhatsApp and place your order. Custom designs are also available!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://wa.me/31685177049?text=Hi! I want to order a cake from your menu."
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#25D366] text-white px-8 py-4 rounded-full font-bold flex items-center justify-center gap-2 hover:bg-[#128C7E] transition-colors"
              data-testid="footer-order-btn"
            >
              <MessageCircle size={22} />
              Order on WhatsApp
            </a>
            <a
              href="tel:+31685177049"
              className="bg-white/10 text-white px-8 py-4 rounded-full font-bold flex items-center justify-center gap-2 hover:bg-white/20 transition-colors"
              data-testid="footer-call-btn"
            >
              📞 Call: +31 6 85 17 70 49
            </a>
          </div>
        </div>
      </section>

      {/* Cake Detail Modal */}
      {selectedCake && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedCake(null)}
          data-testid="cake-modal"
        >
          <div 
            className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative">
              <img
                src={selectedCake.image}
                alt={selectedCake.name}
                className="w-full h-64 md:h-80 object-cover"
              />
              {selectedCake.tag && (
                <div className={`absolute top-4 left-4 px-4 py-2 rounded-full text-sm font-bold text-white ${
                  selectedCake.tag === "UTSAV EXCLUSIVE" ? "bg-gradient-to-r from-[#FF9933] to-[#B76E79]" :
                  selectedCake.tag === "NEW MENU" || selectedCake.tag === "NEW" ? "bg-[#93C572]" :
                  "bg-[#B76E79]"
                }`}>
                  {selectedCake.tag}
                </div>
              )}
              <button
                onClick={() => setSelectedCake(null)}
                className="absolute top-4 right-4 w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-lg hover:bg-gray-100 transition-colors"
                data-testid="close-modal"
              >
                ✕
              </button>
            </div>
            <div className="p-6">
              <h2 className="font-heading text-2xl font-bold text-[#2D2D2D] mb-2">
                {selectedCake.name}
              </h2>
              <p className="text-[#555555] mb-6">{selectedCake.desc}</p>
              
              <div className="bg-[#FFF8F0] rounded-xl p-4 mb-6">
                <p className="text-sm text-[#555555]">
                  <span className="font-semibold text-[#FF9933]">💡 Tip:</span> This is just an example! You can customize this cake - choose your own flavor, size, and decoration.
                </p>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href={`https://wa.me/31685177049?text=Hi! I want to order "${selectedCake.name}" cake.`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 bg-[#25D366] text-white py-3 rounded-full font-bold flex items-center justify-center gap-2 hover:bg-[#128C7E] transition-colors"
                  data-testid="modal-order-btn"
                >
                  <MessageCircle size={20} />
                  Order This Cake
                </a>
                <a
                  href={`https://wa.me/31685177049?text=Hi! I want a CUSTOM cake similar to "${selectedCake.name}" but with my own design.`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 bg-[#FF9933] text-white py-3 rounded-full font-bold flex items-center justify-center gap-2 hover:bg-[#B76E79] transition-colors"
                  data-testid="modal-custom-btn"
                >
                  <Sparkles size={20} />
                  Customize This
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MenuPage;
